// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SyncOutlinedSvg from "@ant-design/icons-svg/es/asn/SyncOutlined";
import AntdIcon from '../components/AntdIcon';

var SyncOutlined = function SyncOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SyncOutlinedSvg
  }));
};

SyncOutlined.displayName = 'SyncOutlined';
export default React.forwardRef(SyncOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SyncOutlined.js
// module id = 1901
// module chunks = 0